import React from 'react';
import { Icon } from './Icon.js';
export const IconMessageContent = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 4H2V18H9L11.25 22H12.75L15 18H22V4Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 9H8.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 9H16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M8 13H12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMessageContent.js.map